/**
 * Shared display helpers for messaging limit / quality (client + mirrored server labels).
 * Keep in sync with wabaserver/utils/phoneHealthUtils.js
 */

export const TIER_LABELS = {
  TIER_50: "50",
  TIER_250: "250",
  TIER_1K: "1K",
  TIER_2K: "2K",
  TIER_10K: "10K",
  TIER_100K: "100K",
  TIER_UNLIMITED: "Unlimited",
  TIER_NOT_SET: "Not set",
};

export const QUALITY_LABELS = {
  GREEN: "HIGH",
  YELLOW: "MEDIUM",
  RED: "LOW",
  UNKNOWN: "UNKNOWN",
};

export function formatMessagingLimit(tier) {
  if (!tier) return "—";
  return TIER_LABELS[tier] || String(tier).replace(/^TIER_/, "");
}

export function formatQualityRating(rating) {
  if (!rating) return "—";
  const upper = String(rating).toUpperCase();
  return QUALITY_LABELS[upper] || upper;
}

export function formatNameStatus(status) {
  if (!status) return "—";
  return String(status).replace(/_/g, " ");
}

export function qualityTone(rating) {
  const upper = String(rating || "").toUpperCase();
  if (upper === "GREEN") return "good";
  if (upper === "YELLOW") return "warn";
  if (upper === "RED") return "bad";
  return "neutral";
}

export function nameStatusTone(status) {
  const upper = String(status || "").toUpperCase();
  if (upper === "APPROVED" || upper === "AVAILABLE_WITHOUT_REVIEW") return "good";
  if (upper === "PENDING_REVIEW" || upper === "PENDING" || upper === "DEFERRED") return "warn";
  if (upper === "DECLINED" || upper === "REJECTED" || upper === "EXPIRED") return "bad";
  return "neutral";
}
